import React from 'react';
import { useTranslation } from 'react-i18next';
import LifecycleTypeTab from './LifecycleTypeTab';
import { getOffboardingTaskTypes, addOffboardingTaskType, updateOffboardingTaskType, deleteOffboardingTaskType } from '../../../../../api/Employee/lifecycleSettings';

const OffboardingTaskTypesTab: React.FC = () => {
  const { t } = useTranslation();

  return (
    <LifecycleTypeTab
      title={t('Offboarding Task Types')}
      description={t('Configure task categories for the offboarding process such as asset return, knowledge transfer, and exit interviews')}
      emptyMessage={t('No offboarding task types configured yet')}
      emptyIcon="UserX"
      addLabel={t('Add Offboarding Task Type')}
      editLabel={t('Edit Offboarding Task Type')}
      deleteLabel={t('Delete Offboarding Task Type')}
      nameLabel={t('Task type name')}
      namePlaceholder={t('e.g., Asset Return')}
      successAddMessage={t('Offboarding task type added successfully')}
      successUpdateMessage={t('Offboarding task type updated successfully')}
      successDeleteMessage={t('Offboarding task type deleted successfully')}
      failAddMessage={t('Failed to save offboarding task type')}
      failDeleteMessage={t('Failed to delete offboarding task type')}
      deleteConfirmMessage={t('Are you sure you want to delete')}
      duplicateMessage={t('An offboarding task type with this name already exists')}
      fetchItems={getOffboardingTaskTypes}
      addItem={addOffboardingTaskType}
      updateItem={updateOffboardingTaskType}
      deleteItem={deleteOffboardingTaskType}
      testIdPrefix="offboarding-task-type"
    />
  );
};

export default OffboardingTaskTypesTab;
